import { render, staticRenderFns } from "./Strength.vue?vue&type=template&id=52aa91ea&scoped=true"
import script from "./Strength.vue?vue&type=script&lang=js"
export * from "./Strength.vue?vue&type=script&lang=js"
import style0 from "./Strength.vue?vue&type=style&index=0&id=52aa91ea&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52aa91ea",
  null
  
)

export default component.exports